import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import authService from 'services/auth';
import { Subscription } from 'rxjs';
import AppRouter from 'components/Router';

interface IState {
  opened: boolean;
}

interface IProps {
  appRouter: AppRouter;
  classes?: any;
}

export default class LogoutDialog extends PureComponent<IProps, IState> {
  private subscriptionLogout: Subscription | null;
  private subscriptionUser: Subscription | null;
  constructor(props: any) {
    super(props);
    this.state = { opened: false };
  }

  componentDidMount(): void {
    const redirectCallback = () => {
      this.redirectToLogin();
    };

    this.subscriptionLogout = authService.onLogout().subscribe(redirectCallback);
    this.subscriptionUser = authService.getUser().subscribe((user) => {
      if (!user) redirectCallback();
    });
  }

  componentWillUnmount(): void {
    this.subscriptionLogout.unsubscribe();
    this.subscriptionUser.unsubscribe();
  }

  handleClose = () => {
    this.setState({ opened: false });
  };

  handleClickOpen = () => {
    this.setState({ opened: true });
  };

  redirectToLogin = () => {
    this.props.appRouter.history.push('/login');
    this.handleClose();
  };

  render(): React.ReactNode {
    return (
      <div>
        <Dialog
          open={this.state.opened}
          onClose={this.handleClose}
          disableEscapeKeyDown
          disableBackdropClick
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>Logout</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Você foi desconectado.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.redirectToLogin} color='primary'>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
